<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid form-group" style="background-color: white">
            <h2 class="text-center p-3">รายการคืนสินค้า</h2>
            <br/>
            <!--date-->
            <div class="row form-group">
                <div class="col-6">
                    <label class="col-sm-6 col-form-label text-capitalize text-right">
                        วันที่สร้างรายการคืนสินค้า
                    </label>
                    &nbsp;
                    <date-picker
                        v-model="form.date"
                        type="date"
                        :not-after="currentDate"
                        :format="changeFormat"
                        :lang="lang"
                        :disabled="disable_date"
                        :show-labels="false"
                        placeholder="วันที่ใบคืนสินค้า" >
                    </date-picker>
                </div>
                <div class="col-6">
                    <div class="form-group row" v-if="form.cn_number">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            หมายเลข CN
                        </label>
                        <div class="col-sm-5">
                            <masked-input v-model="form.cn_number"
                                          mask="CN111111111"
                                          placeholder="หมายเลข CN"
                                          class="form-control"
                                          type="text" />
                        </div>
                    </div>
                </div>
            </div>
            <!--cause-->
            <div class="row form-group">
                <label class="col-sm-2 col-form-label text-capitalize text-right">
                    สาเหตุการคืน
                </label>
                &nbsp;
                <label class="col-sm-3 col-form-label text-capitalize">
                    <input  v-model="form.cause_id"
                            type="radio"
                            name="status"
                            value="1"
                            @change="calculateFromCause"
                            checked/>
                    &nbsp;สินค้าเสียหายจากโรงงาน
                </label>
                <label class="col-sm-3 col-form-label text-capitalize">
                    <input  v-model="form.cause_id"
                            type="radio"
                            @change="calculateFromCause"
                            name="status"
                            value="2"/>
                    สินค้าเสียหายจากลูกค้า
                </label>
                <label class="col-sm-3 col-form-label text-capitalize">
                    <input  v-model="form.cause_id"
                            type="radio"
                            @change="calculateFromCause"
                            name="status"
                            value="3"/>
                    สินค้าไม่เสียหาย
                </label>
            </div>
            <!--sale customer-->
            <div class="row form-group">
                <div class="col-sm-4 col-xs-12 row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        รหัสเซลล์
                    </label>
                    <div class="col-sm-8">
                        <multiselect
                                v-model="form.sale"
                                @input="getCustomerFromSale"
                                :options="OptionSeller"
                                :customLabel="saleLabel"
                                placeholder="กรุณาเลือกเซลล์"
                                :show-labels="false"
                                track-by="sale_id">
                        </multiselect>
                    </div>
                </div>
                <div class="col-sm-4 col-xs-12 row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        รหัสลูกค้า
                    </label>
                    <div class="col-sm-8">
                        <multiselect
                                v-model="form.customer"
                                :options="customers"
                                :show-labels="false"
                                track-by="customer_id"
                                :customLabel="customerLabel"
                                @input="getTransportCustomer"
                                placeholder="กรุณาเลือกลูกค้า">
                        </multiselect>
                    </div>
                </div>
            </div>
            <!--customer data-->
            <div class="row" v-if="form.customer" style="padding-left: 30px">
                <div class="form-group" style="padding-right: 20px">
                    <label style="font-weight: bold">ชื่อลูกค้า : </label>
                    <span> {{form.customer.name}}</span>
                </div>
                <div class="form-group" style="padding-right: 20px">
                    <label style="font-weight: bold">เบอร์โทร : </label>
                    <span> {{form.customer.phone}}</span>
                </div>
                <div class="form-group" style="padding-right: 20px" v-if="form.invoice">
                    <label style="font-weight: bold">รถขนส่ง : </label>
                    <span> {{form.invoice.driver.transport_type.name}}</span>
                </div>
                <div class="form-group" style="padding-right: 20px">
                    <label style="font-weight: bold">ประเภทการขนส่ง : </label>
                    <span v-if="form.customer.fixed_rate_status == 1">การขนส่งแบบต่อห่อ</span>
                    <span v-else-if="form.customer.fixed_rate_status == 2">การขนส่งแบบเหมา</span>
                    <span v-else>ไม่มีประเภทการขนส่ง</span>
                </div>
                <div class="form-group" style="padding-right: 20px" v-if="form.invoice">
                    <label style="font-weight: bold">ราคาขนส่ง : </label>
                    <span> {{form.invoice.transport_fee | currency}} บาท</span>
                </div>
            </div>
            <!--transport_customer-->
            <div style="width: 50%; text-align: center; margin-left: 70px" v-if="form.customer">
                <table class="table table-bordered">
                    <tr>
                        <th>ประเภทขนส่ง</th>
                        <th>รถใหญ่</th>
                        <th>รถใหญ่ (รถบริษัท)</th>
                        <th>รถเล็ก (กระบะ)</th>
                    </tr>
                    <tr v-for="transport in transport_customer">
                        <td style="text-align: right">{{transport[0].transport_wrap_name}}</td>
                        <td v-for="item in transport" v-if="item.transport_type_id != 4">
                            <span v-if="item.price > 0">{{item.price}}</span>
                            <span v-else>-</span>
                        </td>
                    </tr>
                </table>
            </div>
            <br>
            <!--แสดงรายการสินค้าที่ต้องการคืน-->
            <div class="col-sm-12 table-responsive" style="min-height: 350px">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th width="50px" scope="col">ลำดับ</th>
                        <th width="200px" scope="col">รหัสสินค้า</th>
                        <th width="200px" scope="col">ชื่อสินค้า</th>
                        <th width="100px" scope="col">จำนวน</th>
                        <th width="110px" scope="col">ราคา</th>
                        <th width="100px" scope="col">เศษ</th>
                        <th width="50px" scope="col">ราคาต่อหน่วยสินค้า</th>
                        <th width="100px" scope="col">จำนวน</th>
                        <th width="100px" scope="col">เพิ่ม / ลบ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--multi-->
                    <tr v-for="(detail,index) in form.details">
                        <td>
                            {{++index}}
                        </td>
                        <td>
                            <template v-if="detail.product">
                                {{detail.product.sku}}
                            </template>
                        </td>
                        <td>
                            <template v-if="detail.product">
                                {{detail.product.name}}
                            </template>
                        </td>
                        <td>
                            <input type="number" class="form-control"
                                   :disabled="disable"
                                   @input="calculateDetailsArray"
                                   v-model="detail.return_quantity"/>
                        </td>
                        <td>
                            <input type="number" class="form-control"
                                   :disabled="disable"
                                   @input="calculateDetailsArray"
                                   v-model="detail.price"/>
                        </td>
                        <td>
                            <input type="number" class="form-control"
                                   :disabled="disable"
                                   @input="calculateDetailsArray"
                                   v-model="detail.remainder"/>
                        </td>
                        <td>
                            <input type="number" class="form-control"
                                   :disabled="disable"
                                   @input="calculateDetailsArray"
                                   v-model="detail.unit_price"/>
                        </td>
                        <td>
                            <input type="number" class="form-control"
                                   :disabled="disable"
                                   v-model="detail.total"/>
                        </td>
                        <td>
                            <a @click="showModalDelete(index-1)">
                                <icon name="trash-alt"></icon>
                            </a>
                        </td>
                    </tr>
                    <!--one-->
                    <tr>
                        <td></td>
                        <td>
                            <multiselect
                                    v-model="detail.product"
                                    :options="optionProducts"
                                    :customLabel="productLabel"
                                    @input="calculateDetail"
                                    placeholder="กรุณาเลือกสินค้า"
                                    :show-labels="false"
                                    track-by="id">
                            </multiselect>
                        </td>
                        <td>
                            <template v-if="detail.product">
                                {{detail.product.name}}
                            </template>
                        </td>
                        <td>
                            <input type="number" class="form-control"
                                   @input="calculateRemainderPrice"
                                   v-model="detail.return_quantity"/>
                        </td>
                        <td>
                            <input type="number" class="form-control"
                                   @input="calculateRemainderPrice"
                                   v-model="detail.price"/>
                        </td>
                        <td>
                            <input type="number" class="form-control"
                                   @input="totalDetail"
                                   v-model="detail.remainder"/>
                        </td>
                        <td>
                            <input type="number" class="form-control"
                                   @input="totalDetail"
                                   v-model="detail.unit_price"/>
                        </td>
                        <td>
                            <input type="number" class="form-control"
                                   v-model="detail.total"/>
                        </td>
                        <td>
                            <button class="btn btn-primary" type="button"
                                    @click="addProducts">+</button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <br/>
            <!--invoice_back-->
            <div style="color: red;">*คืนสินค้าเฉพาะบิลขายที่มีการ บันทึกเรียบร้อย และ ชำระบางส่วน</div><br>
            <div class="row" style="padding-left: 35px">
                <table>
                    <template v-if="form.invoice_back.length > 0" v-for="invoice in form.invoice_back">
                        <tr :class="{selected : form.invoice_back_id.includes(invoice.invoice_id)}">
                            <td>
                                <input type="checkbox" :id="invoice.invoice_id"
                                       :disabled="disable"
                                       v-model="form.invoice_back_id"
                                       :value="invoice.invoice_id"/>
                            </td>
                            <td>
                                <label class="form-check-label" :for="invoice.invoice_id">{{invoice.invoice_number}}</label>
                                <label :for="invoice.invoice_id">(ยอดใบบิล {{invoice.invoice_total | currency}})</label>
                            </td>
                            <td>
                                <input v-model="invoice.cash_back" :disabled="disable"/>
                            </td>
                            <td>
                                <div v-if="form.status_id == 2">
                                    ยอดคงเหลือ {{invoice.invoice_total | currency}}
                                </div>
                                <div v-else>
                                    ยอดคงเหลือ {{invoice.remaining = invoice.cash_back ? parseFloat(invoice.invoice_total) - parseFloat(invoice.cash_back) : invoice.invoice_total | currency}}
                                </div>
                            </td>
                        </tr>
                    </template>
                </table>
            </div>
            <br>
            <!--reason-->
            <div class="col-sm-8 col-xs-12 row form-group" style="padding-left: 35px">
                <label class="col-sm-2 col-xs-12 col-form-label text-capitalize text-left">
                    หมายเหตุ
                </label>
                <div class="col-sm-8 col-xs-12">
                    <textarea
                            class="form-control"
                            rows="5"
                            v-model="form.reason"
                    ></textarea>
                </div>
            </div>
            <br/>
            <!--promotion-->
            <div class="form-group row total-padding">
                <div class="col font-weight-bold">
                    <span>หักคืนโปรโมชั่นสินค้า</span>
                </div>
                <div>
                    <input class="form-control"
                           v-model="form.discount_promotion"
                           placeholder="โปรโมชั่น"/>
                </div>
            </div>
            <!--total-->
            <div class="form-group row total-padding">
                <div class="col font-weight-bold">
                    <span>คืนค่าขนส่งลูกค้า</span>
                </div>
                <div>
                    <input class="form-control"
                           v-model="form.transport_fee"
                           placeholder="ค่าขนส่ง"/>
                </div>
            </div>
            <div class="text-right" style="padding-right: 20px">
                <span style="padding-left: 25px">ยอดที่ต้องคืนทั้งหมด : {{returnPriceTotal | currency}}บาท</span>
            </div>
            <br/>
            <!--save & cancel-->
            <div class="text-right">
                <button @click="saveSaleReturnProducts"
                        class="btn btn-success mb-3"
                        style="margin-right: 20px">
                    <icon name="save"></icon>
                    บันทึก
                </button>
            </div>
            <b-modal
                    ref="delete_item"
                    hide-header
                    hide-footer>
                <delete-confirm-modal @submit="removeDetail">
                </delete-confirm-modal>
            </b-modal>
            <b-modal hide-header hide-footer ref="loading">
                <loading :msg="msg" :status="status_loading" @submit="hideModalLoading"></loading>
            </b-modal>
        </div>
<!--        <pre class="alert alert-primary">{{ save_data }}</pre>-->
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import Multiselect from "vue-multiselect";
    import DatePicker from 'vue2-datepicker'
    import moment from "moment";
    import DeleteConfirmModal from "../../Utility/DeleteConfirmModal";
    import Loading from "../../Utility/Loading";
    import MaskedInput from 'vue-masked-input'

    export default {
        /*
                update การวิธีการคืนสินค้า 13/4/2020
                1.get sale option
                2.get customer option from sale
                3.get transport price (ค่าขนส่งของลูกค้าคนนี้)
                4.get product all for return
                5.get invoice status 1-4 (กรณีที่ยังไม่จ่ายเงิน) for cash back
                6.calculate total and min price in products(ไม่มีราคาต่ำสุดให้เป็น 0 กรณีเสียหายจากลูกค้า) from back-end (เสียหายจากโรงงาน และ ไม่เสียหาย ดึงราคาปัจจุบัน)
        */
        name: "sale-return-products-form",
        props: {
            status: {default: null}
        },
        components: {
            Loading,
            DeleteConfirmModal,
            Multiselect,
            DatePicker,
            MaskedInput,
        },
        data() {
            return {
                disable : false,
                msg : '',
                status_loading : 1,
                disable_date : false,
                delete_index : '',
                customers : [],
                transport_customer : [],
                items: [
                    {
                        text: "รายการคืนสินค้า",
                        to: {name: "sale-return-products-list"}
                    },
                    {
                        text: "เพิ่มเติม",
                        active: true
                    }
                ],
                currentDate: "",
                onSave : false,
                changeFormat: {
                    stringify: (date) => {
                        let date_moment = moment(date).format('YYYY');
                        const year = parseInt(date_moment) + 543;
                        return date ? moment(date).format('DD/MM/'+year) : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
                detail : {
                    product : null,
                    product_id : null,
                    return_quantity : '',
                    remainder : '',
                    price : '',
                    unit_price : 0,
                    total : '',
                },
                save_data : [],
            };
        },
        created() {
            /* 1.get sale option*/
            this.$store.dispatch("Seller/get");
            /* 4.get product all for return*/
            this.getCustomerFromSale();
            this.getTransportCustomer();
            if(this.status == 2){
                this.generateCN();
            }
            console.log(this.form.id);
            console.log(this.status);
            if(this.form.status_id == 2){
                this.disable = true;
            }
        },
        computed: {
            ...mapState({
                form :state=>{
                    return state.SaleReturnProduct.return_form;
                },
                OptionSeller: state =>{
                    return state.Seller.data;
                },
                optionProducts : state=>{
                    return state.Products.product_all;
                },
            }),
            returnPriceTotal(){
                let details_total = 0;
                let transport_price = 0;
                let promotion = 0;
                this.form.details.forEach(detail=>{
                   if(detail.total > 0){
                       details_total = parseFloat(details_total) + parseFloat(detail.total);
                   }
                });
                if(this.form.transport_fee > 0){
                    transport_price = this.form.transport_fee
                }
                if(this.form.discount_promotion > 0){
                    promotion = this.form.discount_promotion;
                }
                let return_price = parseFloat(details_total) + parseFloat(transport_price) - parseFloat(promotion);
                return parseFloat(return_price).toFixed(2);
            },
            validateSave(){
                let sum_cash_back = 0;
                sum_cash_back = this.form.invoice_back.reduce((carry, invoice) => {
                    if(!invoice.cash_back){
                        invoice.cash_back = 0
                    }
                    return carry + parseFloat(invoice.cash_back)
                }, 0);
                sum_cash_back = parseFloat(sum_cash_back).toFixed(2);
                let return_price = this.returnPriceTotal;
                return sum_cash_back == this.returnPriceTotal;
            },
        },
        methods: {
            /* state */
            generateCN(){
                let date = '';
                if(this.form.date){
                    date = moment(this.form.date).format("YYYY-MM-DD");
                }else{
                    this.form.date = null;
                }
                if(date){
                    this.$store.dispatch("SaleReturnProduct/generateCn",date).then(res=>{
                        this.form.cn_number = res;
                    })
                }
            },
            addProducts(){
                if(!this.detail.product){
                    alert('กรุณาเลือกรายการสินค้า');
                }else if(this.form.cause_id == 3 && !this.detail.return_quantity){
                    alert('กรุณาใส่จำนวนที่ต้องการคืน');
                }else{
                    this.$store.dispatch("SaleReturnProduct/addDetail",this.detail).then(()=>{
                        this.clearDetail();
                    });
                }
            },
            removeDetail(submit){
                if(submit){
                    this.$store.dispatch("SaleReturnProduct/removeDetail",this.delete_index);
                }
                this.hideModalDelete();
            },
            /* customLabel */
            saleLabel (option) {
                return `${option.sale_id} - ${option.name}`
            },
            customerLabel (option) {
                return `${option.customer_id} - ${option.store_name}`
            },
            productLabel(option){
                return `${option.sku} - ${option.short_name}`
            },
            getCurrentDate(){
                this.currentDate = moment().format("YYYY-MM-DD");
                this.form.date = this.currentDate;
            },
            /*modal*/
            showModalDelete(index) {
                this.delete_index = index;
                this.$refs.delete_item.show();
            },
            hideModalDelete() {
                this.$refs.delete_item.hide();
            },
            showModalLoading() {
                this.$refs.loading.show();
            },
            hideModalLoading() {
                this.$refs.loading.hide();
            },
            /*clear data*/
            clearDetail(){
                this.detail = {
                    product : null,
                    product_id : null,
                    return_quantity : '',
                    remainder : '',
                    price : '',
                    unit_price : 0,
                    total : '',
                }
            },
            /* api */
            calculateDetail(){
                if(this.detail.product){
                    this.detail.product_id = this.detail.product.id;
                    if(this.form.cause_id == 2){ //คืนจากลูกค้า
                        let data = {
                            product_id : this.detail.product ? this.detail.product.id : '',
                            customer_id : this.form.customer ? this.form.customer.id : '',
                        }
                        this.$store.dispatch("SaleReturnProduct/getReturnMinPrice",data).then(price=>{
                            this.detail.price = price;
                            this.calculateRemainderPrice();
                        });
                    }else{ //สินค้าไม่เสียหาย , สินค้าเสียหายจากโรงงาน
                        this.detail.price = this.detail.product.price;
                        this.calculateRemainderPrice();
                    }
                }
            },
            calculateDetailsArray(){
                if(this.form.details.length > 0){
                    console.log('multi');
                    this.$store.dispatch("SaleReturnProduct/calculateDetails",this.form);
                }
            },
            calculateFromCause(){
                if(this.detail.product){
                    this.calculateDetail();
                }
                if(this.form.details.length > 0){
                    this.calculateDetailsArray();
                }
            },
            /* 2.get customer option from sale*/
            getCustomerFromSale(){
                if(this.form.sale){
                    let sale = this.form.sale;
                    let sale_id = sale.id;
                    this.$store.dispatch("SaleReturnProduct/getCustomerFromSale",sale_id).then(res=>{
                        this.customers = res;
                    });
                }
                else{
                    this.customers = [];
                }
            },
            /* 3.get transport price (ค่าขนส่งของลูกค้าคนนี้)*/
            getTransportCustomer(){
                if(this.form.customer){
                    this.$store.dispatch("SaleReturnProduct/getTransportFromCustomer",this.form.customer.id).then(res=>{
                        this.transport_customer = res;
                    }).then(()=>{
                        if(!this.form.id || this.form.invoice_back.length < 1){
                            this.$store.dispatch("SaleReturnProduct/getInvoiceBack",this.form.customer.id)
                        }
                    });
                }
            },
            /*calculate remainder*/
            calculateRemainderPrice(){
              if(this.detail.product && this.detail.price){
                  if(this.detail.product.pack){
                      this.detail.unit_price = parseFloat(this.detail.price) / parseFloat(this.detail.product.pack.number);
                      this.detail.unit_price = this.detail.unit_price.toFixed(2);
                  }
              }
                this.totalDetail();
            },
            totalDetail(){
                let quantity = 0;
                let price = 0;
                let remainder = 0;
                let unit_price = 0;
                if(this.detail.product){
                    this.detail.product_id = this.detail.product.id;
                }
                if(this.detail.return_quantity > 0){
                    quantity = this.detail.return_quantity
                }
                if(this.detail.price > 0){
                    price = this.detail.price
                }
                if(this.detail.remainder > 0){
                    remainder = this.detail.remainder
                }
                if(this.detail.unit_price > 0){
                    unit_price = this.detail.unit_price;
                }
                if(this.detail.price > 0){
                    price = this.detail.price;
                }
                this.detail.total = (parseFloat(quantity) * parseFloat(price)) + (parseFloat(remainder) * parseFloat(unit_price));
                this.detail.total = parseFloat(this.detail.total).toFixed(2);
            },
            saveSaleReturnProducts(){
                if(!this.form.sale){
                    alert('กรุณาเลือกเซลล์ เพื่อเลือกลูกค้าที่ต้องการคืน')
                }else if(!this.form.cause_id){
                    alert('กรุณาเลือกสาเหตุการคืนสินค้า');
                } else if(!this.form.customer){
                    alert('กรุณาเลือกลูกค้าที่ต้องการคืน');
                }else if(!this.form.date){
                    alert('กรุณาเลือกวันที่ที่ต้องการคืน');
                }else if(this.form.details.length < 1){
                    alert('กรุณาเพิ่มสินค้าที่ต้องการคืน');
                }
                else if(!this.validateSave){
                    alert('ยอดจำนวนเงินที่คืนใน TN ไม่ถูกต้อง');
                }
                else{
                    this.msg = "กำลังบันทึกข้อมูล กรุณารอสักครู่";
                    this.status_loading = 1;
                    this.showModalLoading();
                    let date = moment(this.form.date).format("YYYY-MM-DD");
                    let data = {
                        cn_number : this.form.cn_number,
                        date : date,
                        cause_id : this.form.cause_id,
                        sale_id : this.form.sale.id,
                        status_id : this.form.status_id == 2 ? this.form.status_id : this.status,
                        customer_id : this.form.customer.id,
                        reason : this.form.reason,
                        transport_price : this.form.transport_price,
                        return_price : this.returnPriceTotal,
                        details : this.form.details.length > 0 ? this.form.details : [],
                        invoice_back : this.form.invoice_back.length > 0 ? this.form.invoice_back : [],
                        invoice_back_id : this.form.invoice_back_id.toString(),
                        transport_fee : this.form.transport_fee,
                        discount_promotion : this.form.discount_promotion
                    };
                    console.log(data);
                    this.save_data = data;
                    this.$store.dispatch("SaleReturnProduct/saveSaleReturnProduct",{
                        id : this.form.id,
                        data : data,
                    }).then(res=>{
                        if(res){
                            this.goToSaleReturnProductList();
                        }else{
                            this.msg = "รหัส CN ซ้ำ กรุณาบันทึกใหม่อีกครั้ง";
                            this.status_loading = 3;
                            this.showModalLoading();
                        }
                    }).catch(()=>{
                        this.msg = "บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง";
                        this.status_loading = 3;
                        this.showModalLoading();
                    })
                }
            },
            goToSaleReturnProductList(){
                this.$store.dispatch("SaleReturnProduct/setSaleReturnProduct").then(()=>{
                    this.$store.dispatch("SaleReturnProduct/clearDataForm").then(()=>{
                        this.$router.push({
                            name:"sale-return-products-list"
                        });
                        this.hideModalLoading();
                    });
                })
            },
        }
    };
</script>

<style lang="scss" scoped>
    thead {
        background-color: gray;
    }

    tbody {
        background-color: white;
    }
    textarea {
        resize: none;
    }
    .total-padding{
        padding-right: 20px;
        text-align: right;
    }
    .selected {
        color: #00a699;
    }
</style>
